// @flow
import bugsnag from 'bugsnag-js';
/* eslint-disable */
const bugsnagClient = bugsnag({
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
  notifyReleaseStages: [ 'production' ]
});

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createPlugin from 'bugsnag-react'
import store from './store';
import App from './app';
import { unregister } from './registerServiceWorker';
import './assets/css/index.css';
import { bootIntercom } from './services/intercom-service';
import './i18n';
import './initializeLocales';
import Loader from './components/shared/Loader';
/* eslint-enable */

const ErrorBoundary = bugsnagClient.use(createPlugin(React));

if (!new URLSearchParams(window.location.search).get('frameless')) {
  bootIntercom();
}

ReactDOM.render(
  <ErrorBoundary>
    <Suspense fallback={
      <Loader />
    }
    >
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
  </ErrorBoundary>, document.getElementById('root'));

unregister();



// WEBPACK FOOTER //
// ./src/index.js